type Props = {
    isActive: boolean
    onClick?: any
}

const GridViewIconMobile = ({ isActive, onClick }: Props) => {
    return (
        <svg
            width="18"
            height="16"
            viewBox="0 0 18 16"
            style={{ cursor: 'pointer' }}
            onClick={onClick && onClick}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="9.50084"
                width="7.68085"
                height="7.51023"
                fill={`${isActive ? '#80C2C4' : '#B3DBDC'}`}
            />
            <rect
                x="9.50081"
                y="8.48975"
                width="7.68085"
                height="7.51023"
                fill={`${isActive ? '#80C2C4' : '#B3DBDC'}`}
            />
            <rect
                x="0.818283"
                width="7.68085"
                height="7.51023"
                fill={`${isActive ? '#80C2C4' : '#B3DBDC'}`}
            />
            <rect
                x="0.818283"
                y="8.48975"
                width="7.68085"
                height="7.51023"
                fill={`${isActive ? '#80C2C4' : '#B3DBDC'}`}
            />
        </svg>
    )
}

export default GridViewIconMobile
